import TransactionModal from "./transactionModal.js";

export default class ChangeDateModal extends TransactionModal {
  constructor() {
    super("change-date-modal", window.currentCompany.id);
    this.$transactionsContainer = this.$form.querySelector(
      "[data-transactions-container]"
    );
    this.transactions = [];

    this.formFields = [
      {
        name: "date",
        varType: "string",
        required: true,
      },
    ];

    this.whenReady();
  }

  reset() {
    this.transactions = [];
    this.$transactionsContainer.innerHTML = "";
  }

  add(transaction) {
    const $transaction = document.getElementById(
      transaction.type === peque.TRANSACTION_TYPE_CONVERTIBLE_LOAN
        ? "convertible-" + transaction.loan.id
        : "transaction-" + transaction.id
    );

    // transaction got deleted or something
    if (!$transaction) {
      return;
    }

    this.transactions.push(transaction.id);

    const clone = $transaction.querySelector(".row").cloneNode(true);
    clone.classList.add("mt-2");
    this.$transactionsContainer.append(clone);
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.ids = this.transactions;

        peque
          .api("transactions/change_date", JSON.stringify(data), "post")
          .then((response) => {
            location.reload();
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);

        if (typeof error.el === "undefined") {
          console.error(error);
          return;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
